// ============================================
// КОМПОНЕНТ ВЫБОРА РЕГИОНА
// ============================================

// ---------- Элементы ----------
let btn, modal, curCountry, curFlag, logoFlag, options, closeBtn;

// ---------- Функции ----------
function fixLogoWidth() {
  const logo = document.querySelector('.logo');
  if (!logo) return;
  
  // Проверяем, загружено ли изображение logo (проверяем и complete, и naturalWidth)
  const logoImg = logo.querySelector('img');
  if (logoImg && (!logoImg.complete || logoImg.naturalWidth === 0)) {
    // Если изображение еще не загружено, возвращаемся без изменений
    // Функция будет вызвана снова после загрузки изображения
    return;
  }
  
  const windowWidth = window.innerWidth;
  
  // Фиксируем ширину при 769px+ или при 353px и меньше
  if (windowWidth > 768 || windowWidth <= 353) {
    // Временно устанавливаем "Узбекистан" для измерения максимальной ширины
    const regionBtn = document.getElementById('regionBtn');
    const curCountryEl = document.getElementById('curCountry');
    if (regionBtn && curCountryEl) {
      const originalText = curCountryEl.textContent;
      curCountryEl.textContent = 'Узбекистан';
      
      // Принудительно пересчитываем layout для точного измерения
      void logo.offsetWidth; // Принудительный reflow
      
      const maxWidth = logo.offsetWidth;
      
      // Устанавливаем фиксированную ширину для logo только если измерение валидно
      if (maxWidth > 0) {
        logo.style.width = maxWidth + 'px';
        logo.style.minWidth = maxWidth + 'px';
      }
      
      curCountryEl.textContent = originalText;
    }
  } else {
    // На промежуточных размерах (354px - 768px) не фиксируем ширину
    logo.style.width = '';
    logo.style.minWidth = '';
  }
}

function updateRegion({name, flag}) {
  // Определяем текущий язык и переводим название страны
  const lang = localStorage.getItem('siteLanguage') || 'ru';
  let translatedName = name;
  
  if (typeof translations !== 'undefined' && translations[lang]) {
    const t = translations[lang];
    // Определяем, какой регион выбран (по русскому названию из data-country)
    if (name === 'Узбекистан') {
      translatedName = t.region_uzbekistan;
    } else if (name === 'Россия') {
      translatedName = t.region_russia;
    }
  }
  
  // Устанавливаем переведенное название страны
  if (curCountry) curCountry.textContent = translatedName;
  if (curFlag) curFlag.src = flag;
  if (logoFlag) logoFlag.src = flag;
  
  // Обновляем визуальное состояние кнопок
  const allOptions = document.querySelectorAll(".country_option");
  allOptions.forEach(opt => {
    const optCountry = opt.getAttribute("data-country");
    if (optCountry === name) {
      // Выбранный регион - добавляем класс active
      opt.classList.add("active");
      opt.setAttribute("data-selected", "true");
    } else {
      // Невыбранный регион - убираем класс active
      opt.classList.remove("active");
      opt.setAttribute("data-selected", "false");
    }
  });
  
  // Фиксируем ширину logo после смены региона
  setTimeout(() => {
    fixLogoWidth();
  }, 50);
  
  // Обновляем текст модального окна в зависимости от выбранного региона
  const modalHeader = document.querySelector('.modal_header');
  if (modalHeader && typeof translations !== 'undefined') {
    const t = translations[lang];
    if (t) {
      if (name === 'Узбекистан' || name === 'Uzbekistan') {
        modalHeader.innerHTML = t.region_modal_text_uzbekistan || t.region_modal_text;
      } else {
        modalHeader.innerHTML = t.region_modal_text;
      }
    }
  }
}

// Экспортируем updateRegion глобально
window.updateRegion = updateRegion;

function saveRegion(r) {
  const regionJson = JSON.stringify(r);
  // Редирект при смене региона — и для средней школы (как на детсаду/primary), URL должен совпадать с @country на сервере.

  if (typeof window.setCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined' && typeof window.COOKIE_DAYS !== 'undefined') {
    window.setCookie(window.COOKIE_NAME, regionJson, window.COOKIE_DAYS);
  } else if (typeof setCookie === 'function' && typeof COOKIE_NAME !== 'undefined' && typeof COOKIE_DAYS !== 'undefined') {
    setCookie(COOKIE_NAME, regionJson, COOKIE_DAYS);
  } else {
    console.error('Не удалось сохранить регион: функции setCookie или константы не найдены');
  }

  // Редирект на URL с нужной страной — слайды и контент зависят от региона на сервере
  // Англ + Россия = en-gb (не en-ru), Рус + Россия = ru-ru, Узбекистан = uz для обоих языков
  const pathMatch = window.location.pathname.match(/^\/([a-z]{2})-([a-z]{2})(\/.*)?$/);
  const lang = pathMatch ? pathMatch[1] : (localStorage.getItem('siteLanguage') || 'ru');
  const isRussia = r.name === 'Россия' || r.name === 'Russia';
  const isUzbekistan = r.name === 'Узбекистан' || r.name === 'Uzbekistan';
  const newCountry = isUzbekistan ? 'uz' : (lang === 'en' ? 'gb' : 'ru');
  const currentCountry = pathMatch ? pathMatch[2] : null;
  if (pathMatch && currentCountry !== newCountry) {
    const rest = pathMatch[3] || '/';
    window.location.href = '/' + lang + '-' + newCountry + rest;
    return;
  }

  updateRegion(r);
  applyRegion(r.name);

  if (typeof window.setGeoConfirmed === 'function') {
    window.setGeoConfirmed();
  } else {
    console.warn('Функция setGeoConfirmed не найдена');
  }

  closeModal();
}

function openModal() {
  if (modal) modal.classList.add("open");
  if (btn) btn.classList.add("active");
}

function closeModal() {
  if (modal) modal.classList.remove("open");
  if (btn) btn.classList.remove("active");
}

// Функция для инициализации обработчиков кнопок скачивания PDF в третьей карточке block13
function initBlock13DownloadButtons() {
  const block13Card3 = document.querySelector('.block13_card:nth-child(3)');
  if (!block13Card3) return;
  
  const schoolBtn = block13Card3.querySelector('.block13_card_btn_school');
  const kindergartenBtn = block13Card3.querySelector('.block13_card_btn_kindergarten');
  
  // Обработчик для кнопки "Школа"
  function handleSchoolBtnClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Открываем PDF в новой вкладке
    window.open(landingAssetPath('/landing_2025/src/img/Accreditation/ЛИЦЕНЗИЯ № УУТ 0067 - shkola.pdf'), '_blank');
  }
  
  // Обработчик для кнопки "Детский сад"
  function handleKindergartenBtnClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Открываем PDF в новой вкладке
    window.open(landingAssetPath('/landing_2025/src/img/Accreditation/ЛИЦЕНЗИЯ № MT 0865 - detskiy sad.pdf'), '_blank');
  }
  
  // Удаляем старые обработчики, если они есть, чтобы избежать дублирования
  if (schoolBtn) {
    // Клонируем элемент, чтобы удалить все старые обработчики
    const newSchoolBtn = schoolBtn.cloneNode(true);
    schoolBtn.parentNode.replaceChild(newSchoolBtn, schoolBtn);
    newSchoolBtn.addEventListener('click', handleSchoolBtnClick);
  }
  
  if (kindergartenBtn) {
    // Клонируем элемент, чтобы удалить все старые обработчики
    const newKindergartenBtn = kindergartenBtn.cloneNode(true);
    kindergartenBtn.parentNode.replaceChild(newKindergartenBtn, kindergartenBtn);
    newKindergartenBtn.addEventListener('click', handleKindergartenBtnClick);
  }
}

// Функция applyRegion должна быть доступна глобально, так как используется в других местах
function applyRegion(name) {
  // Показываем/скрываем блок 13 (Лицензии и аккредитации) в зависимости от региона
  const block13 = document.getElementById('block13');
  if (block13) {
    if (name === 'Узбекистан' || name === 'Uzbekistan') {
      block13.style.display = 'block';
    } else {
      block13.style.display = 'none';
    }
  }
  
  // Обновляем изображение в третьей карточке block13 в зависимости от региона
  const block13Card3 = document.querySelector('.block13_card:nth-child(3)');
  if (block13Card3) {
    const block13Card3ImageLeft = block13Card3.querySelector('.block13_card_image_left');
    if (block13Card3ImageLeft) {
      if (name === 'Узбекистан' || name === 'Uzbekistan') {
        // Для узбекской версии используем новое изображение
        block13Card3ImageLeft.src = landingAssetPath('/landing_2025/src/img/Accreditation/ЛИЦЕНЗИЯ_№_УУТ_0067_shkola.webp');
      } else {
        // Для русской версии оставляем оригинальное изображение
        block13Card3ImageLeft.src = landingAssetPath('/landing_2025/src/img/Accreditation/fake-lic_ingener_converted.webp');
      }
    }
  }
  
  // Инициализируем обработчики кнопок скачивания PDF в третьей карточке
  initBlock13DownloadButtons();
  
  // Обновляем текст программы в block21_top
  const block21Top = document.querySelector('.block21_top');
  if (block21Top) {
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
    const programLinks = block21Top.querySelectorAll('.block21_link');
    programLinks.forEach(link => {
      const linkText = link.textContent.trim();
      const isUzbekistan = name === 'Узбекистан' || name === 'Uzbekistan';
      
      // Обработка "Международная" / "International Programme" - для узбекской версии заменяем на "Кембриджская программа"
      if (linkText === 'Международная' || linkText === 'Международная программа' ||
        linkText === 'International Programme' || linkText === 'International Program' ||
        linkText === 'Cambridge Programme' || linkText === 'Cambridge Program' ||
        linkText === 'Кембриджская программа') {
        if (isUzbekistan && t && t.block21_program_cambridge_uz) {
          link.textContent = t.block21_program_cambridge_uz;
        } else if (t && t.block21_program_cambridge) {
          link.textContent = t.block21_program_cambridge;
        }
      } else if (linkText === 'Российская программа' || linkText === 'Russian Programme' || linkText === 'Russian program') {
        if (isUzbekistan) {
          // Для Узбекистана используем "Локальная программа" / "National Programme"
          if (t && t.block21_program_russian_uz) {
            link.textContent = t.block21_program_russian_uz;
          } else {
            link.textContent = lang === 'en' ? 'National Programme' : 'Локальная программа';
          }
        } else {
          // Для России используем "Российская программа" / "Russian Programme"
          if (t && t.block21_program_russian) {
            link.textContent = t.block21_program_russian;
          } else {
            link.textContent = lang === 'en' ? 'Russian Programme' : 'Российская программа';
          }
        }
      } else if (linkText === 'Узбекская программа' || linkText === 'Локальная программа' || linkText === 'National Programme' || linkText === 'Local program' || linkText === 'Local Programme') {
        if (name === 'Россия' || name === 'Russia') {
          // Для России используем "Российская программа" / "Russian Programme"
          if (t && t.block21_program_russian) {
            link.textContent = t.block21_program_russian;
          } else {
            link.textContent = lang === 'en' ? 'Russian Programme' : 'Российская программа';
          }
        } else {
          // Для Узбекистана используем "Локальная программа" / "National Programme"
          if (t && t.block21_program_russian_uz) {
            link.textContent = t.block21_program_russian_uz;
          } else {
            link.textContent = lang === 'en' ? 'National Programme' : 'Локальная программа';
          }
        }
      }
    });
  }
  
  // Обновляем текст программы в block21_column_list
  const block21ColumnLists = document.querySelectorAll('.block21_column_list');
  block21ColumnLists.forEach(list => {
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
    const programLinks = list.querySelectorAll('.block21_link');
    programLinks.forEach(link => {
      const linkText = link.textContent.trim();
      const isUzbekistan = name === 'Узбекистан' || name === 'Uzbekistan';
      
      // Обработка "Международная" / "International Programme" - для узбекской версии заменяем на "Кембриджская программа"
      if (linkText === 'Международная' || linkText === 'Международная программа' ||
        linkText === 'International Programme' || linkText === 'International Program' ||
        linkText === 'Cambridge Programme' || linkText === 'Cambridge Program' ||
        linkText === 'Кембриджская программа') {
        if (isUzbekistan && t && t.block21_program_cambridge_uz) {
          link.textContent = t.block21_program_cambridge_uz;
        } else if (t && t.block21_program_cambridge) {
          link.textContent = t.block21_program_cambridge;
        }
      } else if (linkText === 'Российская программа' || linkText === 'Russian Programme' || linkText === 'Russian program') {
        if (isUzbekistan) {
          // Для Узбекистана используем "Локальная программа" / "National Programme"
          if (t && t.block21_program_russian_uz) {
            link.textContent = t.block21_program_russian_uz;
          } else {
            link.textContent = lang === 'en' ? 'National Programme' : 'Локальная программа';
          }
        } else {
          // Для России используем "Российская программа" / "Russian Programme"
          if (t && t.block21_program_russian) {
            link.textContent = t.block21_program_russian;
          } else {
            link.textContent = lang === 'en' ? 'Russian Programme' : 'Российская программа';
          }
        }
      } else if (linkText === 'Узбекская программа' || linkText === 'Локальная программа' || linkText === 'National Programme' || linkText === 'Local program' || linkText === 'Local Programme') {
        if (name === 'Россия' || name === 'Russia') {
          // Для России используем "Российская программа" / "Russian Programme"
          if (t && t.block21_program_russian) {
            link.textContent = t.block21_program_russian;
          } else {
            link.textContent = lang === 'en' ? 'Russian Programme' : 'Российская программа';
          }
        } else {
          // Для Узбекистана используем "Локальная программа" / "National Programme"
          if (t && t.block21_program_russian_uz) {
            link.textContent = t.block21_program_russian_uz;
          } else {
            link.textContent = lang === 'en' ? 'National Programme' : 'Локальная программа';
          }
        }
      }
    });
  });
  
  // Обновляем текст программы в dropdown меню навигации
  const navBarDropdowns = document.querySelectorAll('.nav-bar .dropdown-menu a, .nav-bar ul li.dropdown a');
  navBarDropdowns.forEach(link => {
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
    const linkText = link.textContent.trim();
    const isUzbekistan = name === 'Узбекистан' || name === 'Uzbekistan';
    
    // Проверяем различные варианты текста программы
    if (linkText === 'Российская программа' || linkText === 'Russian Programme' || linkText === 'Russian program' ||
      linkText === 'Узбекская программа' || linkText === 'Локальная программа' ||
      linkText === 'National Programme' || linkText === 'Local program' || linkText === 'Local Programme') {
      if (isUzbekistan) {
        // Для Узбекистана используем специальный ключ перевода
        if (t && t.nav_program_russian_uz) {
          link.textContent = t.nav_program_russian_uz;
        } else {
          link.textContent = lang === 'en' ? 'National Programme' : 'Локальная программа';
        }
      } else {
        // Для России используем стандартный ключ перевода
        if (t && t.nav_program_russian) {
          link.textContent = t.nav_program_russian;
        } else {
          link.textContent = lang === 'en' ? 'Russian Programme' : 'Российская программа';
        }
      }
    }
  });
  
  // Пункт "Устав" только для Узбекистана (навигация и футер)
  const isUzbekistanCharter = name === 'Узбекистан' || name === 'Uzbekistan';
  const charterNavLinks = document.querySelectorAll('.js-charter-nav');
  charterNavLinks.forEach(link => {
    link.style.display = isUzbekistanCharter ? '' : 'none';
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
    if (t && isUzbekistanCharter) {
      link.textContent = t.nav_world_charter;
    }
  });
  
  const charterFooterLinks = document.querySelectorAll('.js-charter-footer');
  charterFooterLinks.forEach(link => {
    link.style.display = isUzbekistanCharter ? '' : 'none';
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
    if (t && isUzbekistanCharter) {
      link.textContent = t.block21_world_charter;
    }
  });
  
  // Изменение порядка элементов в dropdown "Стоимость" и "Кампусы" для узбекской версии
  const isUzbekistanOrder = name === 'Узбекистан' || name === 'Uzbekistan';
  const lang = localStorage.getItem('siteLanguage') || 'ru';
  const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
  
  if (t) {
    const dropdownMenus = document.querySelectorAll('.nav-bar ul li.bar.dropdown');
    dropdownMenus.forEach((menuItem, index) => {
      const dropdownMenu = menuItem.querySelector('.dropdown-menu');
      if (!dropdownMenu) return;
      
      // Подменю "Стоимость" (индекс 4)
      if (index === 4) {
        const menuItems = Array.from(dropdownMenu.querySelectorAll('li'));
        if (menuItems.length >= 6) {
          const tashkentItem = menuItems.find(item => {
            const link = item.querySelector('a');
            return link && (link.textContent.trim() === t.nav_cost_tashkent || link.textContent.trim() === 'Ташкент' || link.textContent.trim() === 'Tashkent');
          });
          const firstItem = menuItems[0];
          
          if (isUzbekistanOrder && tashkentItem && firstItem && tashkentItem !== firstItem) {
            dropdownMenu.insertBefore(tashkentItem, firstItem.nextSibling);
          } else if (!isUzbekistanOrder && tashkentItem) {
            // Для русской версии возвращаем исходный порядок
            const currentItems = Array.from(dropdownMenu.querySelectorAll('li'));
            if (tashkentItem !== currentItems[currentItems.length - 1]) {
              dropdownMenu.appendChild(tashkentItem);
            }
          }
        }
      }
      
      // Подменю "Кампусы" (индекс 5)
      if (index === 5) {
        const menuItems = Array.from(dropdownMenu.querySelectorAll('li'));
        if (menuItems.length >= 6) {
          const tashkentItem = menuItems.find(item => {
            const link = item.querySelector('a');
            return link && (link.textContent.trim() === t.nav_campuses_tashkent || link.textContent.trim() === 'Ташкент' || link.textContent.trim() === 'Tashkent');
          });
          const firstItem = menuItems[0];
          
          if (isUzbekistanOrder && tashkentItem && firstItem && tashkentItem !== firstItem) {
            dropdownMenu.insertBefore(tashkentItem, firstItem.nextSibling);
          } else if (!isUzbekistanOrder && tashkentItem) {
            // Для русской версии возвращаем исходный порядок
            const currentItems = Array.from(dropdownMenu.querySelectorAll('li'));
            if (tashkentItem !== currentItems[currentItems.length - 1]) {
              dropdownMenu.appendChild(tashkentItem);
            }
          }
        }
      }
    });
  }
  
  // Изменение порядка элементов в block21_column_list "Стоимость" и "Кампусы" для узбекской версии
  const block21Container = document.querySelector('.block21_container');
  if (block21Container) {
    const block21Columns = block21Container.querySelectorAll('.block21_column');
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
    
    if (t) {
      block21Columns.forEach(column => {
        const columnTitle = column.querySelector('.block21_column_title');
        if (!columnTitle) return;
        
        const titleText = columnTitle.textContent.trim();
        const columnList = column.querySelector('.block21_column_list');
        if (!columnList) return;
        
        const listItems = Array.from(columnList.querySelectorAll('li'));
        
        // Колонка "Стоимость"
        if (titleText === t.block21_cost || titleText === 'Стоимость' || titleText === 'Cost') {
          if (isUzbekistanOrder && listItems.length >= 6) {
            const tashkentItem = listItems.find(item => {
              const link = item.querySelector('a');
              return link && (link.textContent.trim() === t.campus_name_tashkent || link.textContent.trim() === 'Ташкент' || link.textContent.trim() === 'Tashkent');
            });
            const tuitionItem = listItems[0];
            
            if (tashkentItem && tuitionItem && tashkentItem !== tuitionItem) {
              columnList.insertBefore(tashkentItem, tuitionItem.nextSibling);
            }
          } else if (!isUzbekistanOrder && listItems.length >= 6) {
            const tashkentItem = listItems.find(item => {
              const link = item.querySelector('a');
              return link && (link.textContent.trim() === t.campus_name_tashkent || link.textContent.trim() === 'Ташкент' || link.textContent.trim() === 'Tashkent');
            });
            if (tashkentItem && tashkentItem !== listItems[listItems.length - 1]) {
              columnList.appendChild(tashkentItem);
            }
          }
        }
        
        // Колонка "Кампусы"
        if (titleText === t.block21_campuses || titleText === 'Кампусы' || titleText === 'Campuses') {
          if (isUzbekistanOrder && listItems.length >= 6) {
            const tashkentItem = listItems.find(item => {
              const link = item.querySelector('a');
              return link && (link.textContent.trim() === t.campus_name_tashkent || link.textContent.trim() === 'Ташкент' || link.textContent.trim() === 'Tashkent');
            });
            const allItem = listItems[0];
            
            if (tashkentItem && allItem && tashkentItem !== allItem) {
              columnList.insertBefore(tashkentItem, allItem.nextSibling);
            }
          } else if (!isUzbekistanOrder && listItems.length >= 6) {
            const tashkentItem = listItems.find(item => {
              const link = item.querySelector('a');
              return link && (link.textContent.trim() === t.campus_name_tashkent || link.textContent.trim() === 'Ташкент' || link.textContent.trim() === 'Tashkent');
            });
            if (tashkentItem && tashkentItem !== listItems[listItems.length - 1]) {
              columnList.appendChild(tashkentItem);
            }
          }
        }
      });
    }
  }
  
  // Обновляем иконки: для Узбекистана - ico_double-program UZ.webp, для России - icon_1.webp
  const icon1Images = document.querySelectorAll(
    `img[src="${landingAssetPath('/landing_2025/src/icon/icon_1.webp')}"], img[src="${landingAssetPath('/landing_2025/src/img/icons/ico_double-program UZ.webp')}"]`
  );
  icon1Images.forEach(img => {
    if (name === 'Узбекистан' || name === 'Uzbekistan') {
      img.src = landingAssetPath('/landing_2025/src/img/icons/ico_double-program UZ.webp');
    } else {
      img.src = landingAssetPath('/landing_2025/src/icon/icon_1.webp');
    }
  });
  
  // Устанавливаем код страны и флаг для ВСЕХ полей телефона (включая block7) в зависимости от региона
  const isUzbekistan = name === 'Узбекистан' || name === 'Uzbekistan';
  const phoneCode = isUzbekistan ? '+998' : '+7';
  const phoneFlagEmoji = isUzbekistan ? (window.getCountryFlagEmoji ? window.getCountryFlagEmoji('uz') : '🇺🇿') : (window.getCountryFlagEmoji ? window.getCountryFlagEmoji('ru') : '🇷🇺');
  const phoneFlagIso = isUzbekistan ? 'uz' : 'ru';
  
  const updateFlagElement = (flagEl) => {
    if (!flagEl) return;
    if (typeof window.ensurePhoneFlagEmojiElement === 'function' && flagEl.id) {
      window.ensurePhoneFlagEmojiElement(flagEl.id, phoneFlagIso);
      return;
    }

    if (flagEl.tagName === 'SPAN' && flagEl.classList.contains('flag-emoji')) {
      flagEl.textContent = phoneFlagEmoji;
      flagEl.classList.add('phoneFlagImg');
      return;
    }

    const parent = flagEl.parentNode;
    if (!parent) return;
    const emojiSpan = document.createElement('span');
    emojiSpan.className = 'flag-emoji phoneFlagImg';
    emojiSpan.textContent = phoneFlagEmoji;
    if (flagEl.id) emojiSpan.id = flagEl.id;
    parent.replaceChild(emojiSpan, flagEl);
  };
  
  const allPhoneWrappers = document.querySelectorAll('.phone_wrapper');
  allPhoneWrappers.forEach(wrapper => {
    const phoneCodeEl = wrapper.querySelector('.phone-code');
    // Используем ID (phoneFlagImg*, phoneFlagImgBlock7) — это элемент отображения, не опции в выпадающем списке
    const flagEl = wrapper.querySelector('[id^="phoneFlagImg"]') ||
      wrapper.querySelector('.phone_flag_selector > .phoneFlagImg') ||
      wrapper.querySelector('.phone_flag_selector > .flag-emoji') ||
      wrapper.querySelector('.phoneFlagImg') ||
      wrapper.querySelector('.phone_flag_selector .flag-emoji');
    const phoneInput = wrapper.querySelector('input[type="tel"]');
    
    if (phoneCodeEl) {
      phoneCodeEl.textContent = phoneCode;
    }
    updateFlagElement(flagEl);
    if (phoneInput) {
      phoneInput.value = '';
      phoneInput.dataset.countryCode = phoneCode;
    }
  });
  
  // Обновляем ограничения и placeholder для полей телефона (кроме block7)
  // В бандле функция только на window (script.js подключается после regionSelector)
  if (typeof window.updatePhoneInputsLimits === 'function') {
    // Вызываем сразу после обновления кодов стран
    window.updatePhoneInputsLimits(name);
    
    // Также вызываем через небольшую задержку для надежности
    setTimeout(() => {
      window.updatePhoneInputsLimits(name);
    }, 100);
    
    // Дополнительно обновляем placeholder для всех полей phone_step2 после небольшой задержки
    // чтобы убедиться, что код страны уже обновлен
    setTimeout(() => {
      ['phone_step2_1', 'phone_step2_2', 'phone_step2_3', 'phone_step2_4'].forEach(phoneId => {
        const phoneInput = document.getElementById(phoneId);
        if (phoneInput) {
          const phoneWrapper = phoneInput.closest('.phone_wrapper');
          if (phoneWrapper) {
            const phoneCodeEl = phoneWrapper.querySelector('.phone-code');
            if (phoneCodeEl) {
              const code = phoneCodeEl.textContent.trim();
              const country = window.getCountryByCode && window.getCountryByCode(code);
              if (country && country.placeholder) {
                phoneInput.placeholder = country.placeholder;
              }
            }
          }
        }
      });
    }, 200);
  }
  
  // Обновляем страну и placeholder для полей с intl-tel-input после смены региона
  const targetCountry = isUzbekistan ? 'uz' : 'ru';
  const correctPlaceholder = isUzbekistan ? '99 999 99 99' : '999 999 99 99';
  
  const updateIntlTelInputPlaceholder = (phoneInput, targetCountryCode) => {
    if (!phoneInput) return;
    
    try {
      // Для полей с intl-tel-input устанавливаем страну
      if (phoneInput._iti && typeof phoneInput._iti.setCountry === 'function') {
        phoneInput._iti.setCountry(targetCountryCode);
      }
      
      // Прямо устанавливаем placeholder, как в block7
      phoneInput.placeholder = correctPlaceholder;
      phoneInput.dataset.correctPlaceholder = correctPlaceholder;
      
      // Дополнительно обновляем через intl-tel-input API
      if (phoneInput._iti) {
        setTimeout(() => {
          try {
            const countryData = phoneInput._iti.getSelectedCountryData();
            const countryCode = countryData ? countryData.dialCode : null;
            if (countryCode) {
              const country = window.getCountryByCode && window.getCountryByCode('+' + countryCode);
              if (country && country.placeholder) {
                phoneInput.placeholder = country.placeholder;
                phoneInput.dataset.correctPlaceholder = country.placeholder;
              }
            }
          } catch (e) {
            // Используем уже установленный placeholder
          }
        }, 200);
      }
    } catch (e) {
    }
  };
  
  setTimeout(() => {
    // Обновляем для всех полей с intl-tel-input в form_hover
    ['phone', 'phone2', 'phone3', 'phone4'].forEach(phoneId => {
      const phoneInput = document.getElementById(phoneId);
      if (phoneInput) {
        updateIntlTelInputPlaceholder(phoneInput, targetCountry);
      }
    });
  }, 400);
  
  // Обновляем ограничения и placeholder для block7 (уже обновлён в общем цикле выше)
  const phoneCodeBlock7 = document.getElementById("phoneCodeBlock7");
  if (phoneCodeBlock7 && typeof window.updateBlock7PhoneLimits === 'function') {
    window.updateBlock7PhoneLimits();
  }
  if (phoneCodeBlock7 && typeof window.updateBlock7DownloadButton === 'function') {
    window.updateBlock7DownloadButton();
  }
  
  // Определяем кампус по умолчанию в зависимости от региона
  // Для Узбекистана - Ташкент, для России - Горки
  const defaultCampusId = isUzbekistan ? 'tashkent' : 'gorki';
  
  // Проверяем, был ли уже выбран кампус пользователем
  // Проверяем активную кнопку кампуса в block20 и селектор кампуса
  let currentCampusId = null;
  
  // Проверяем активную кнопку кампуса в block20
  const block20CampusButtons = document.querySelectorAll('.block20_campus_btn');
  block20CampusButtons.forEach(btn => {
    if (btn.classList.contains('active')) {
      currentCampusId = btn.getAttribute('data-campus');
    }
  });
  
  // Если не нашли через кнопки, проверяем селектор кампуса
  if (!currentCampusId) {
    const block20SelectedCampus = document.getElementById('block20SelectedCampus');
    if (block20SelectedCampus) {
      const selectedText = block20SelectedCampus.textContent.trim();
      const lang = localStorage.getItem('siteLanguage') || 'ru';
      const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
      if (t) {
        // Проверяем, какой кампус соответствует тексту
        const campusNameMap = {
          [t.campus_name_skolkovo]: 'skolkovo',
          [t.campus_name_moscow]: 'moscow',
          [t.campus_name_gorki]: 'gorki',
          [t.campus_name_spb]: 'spb',
          [t.campus_name_tashkent]: 'tashkent'
        };
        currentCampusId = campusNameMap[selectedText] || null;
      }
    }
  }
  // Block12 (цены): иначе applyRegion через 400ms затирает селектор, ориентируясь только на block20
  if (!currentCampusId) {
    const block12Selected = document.getElementById('block12SelectedCampus');
    if (block12Selected && typeof window.getBlock12CampusSlug === 'function') {
      currentCampusId = window.getBlock12CampusSlug(block12Selected.textContent.trim());
    }
  }
  if (!currentCampusId) {
    const block12Root = document.getElementById('block12');
    if (block12Root && block12Root.dataset && block12Root.dataset.defaultCampus) {
      currentCampusId = block12Root.dataset.defaultCampus;
    }
  }
  
  // Если кампус не выбран или выбран кампус из другого региона, устанавливаем кампус по умолчанию
  // Для Узбекистана доступен только Ташкент, для России - все кроме Ташкента
  let campusToSelect = defaultCampusId;
  if (currentCampusId) {
    if (isUzbekistan && currentCampusId === 'tashkent') {
      // Для Узбекистана, если уже выбран Ташкент, оставляем его
      campusToSelect = 'tashkent';
    } else if (!isUzbekistan && currentCampusId !== 'tashkent') {
      // Для России, если выбран любой кампус кроме Ташкента, оставляем его
      campusToSelect = currentCampusId;
    }
    // В остальных случаях используем кампус по умолчанию
  }
  
  // Используем selectBlock20Campus для обновления кампуса БЕЗ обновления карты (по умолчанию)
  // Вызываем с небольшой задержкой, чтобы DOM был готов
  // Увеличиваем задержку, чтобы избежать конфликта с другими вызовами
  setTimeout(() => {
    if (window.block12CampusChosenByUser) return;
    if (typeof window.selectBlock20Campus === 'function') {
      window.selectBlock20Campus(campusToSelect, false); // false = не обновлять карту
    } else if (typeof selectBlock20Campus === 'function') {
      selectBlock20Campus(campusToSelect, false); // false = не обновлять карту
    } else {
      // Fallback: используем syncCampusSelection и updateCampusInfo
      if (typeof syncCampusSelection === 'function') {
        syncCampusSelection(campusToSelect);
      }
      setTimeout(() => {
        if (typeof updateCampusInfo === 'function') {
          updateCampusInfo(campusToSelect);
        } else if (typeof window.updateCampusInfo === 'function') {
          window.updateCampusInfo(campusToSelect);
        }
      }, 100);
    }
  }, 400);
  
  // Загружаем фотографии для выбранного кампуса в slider_container (block5)
  // Используем campusToSelect вместо defaultCampusId
  setTimeout(() => {
    if (typeof loadCampusImages === 'function') {
      // Загружаем фотографии территории для выбранного кампуса
      loadCampusImages(campusToSelect, "tgn");
    }
  }, 200);
  
  // Обновляем преподавателей для выбранного кампуса
  // НЕ перезаписываем block14, если пользователь уже выбрал кампус вручную (en-uz + UZB)
  setTimeout(() => {
    const campusForTeachers = window.block14UserSelectedCampus || campusToSelect;
    if (typeof window.applyTeachers === 'function') {
      window.applyTeachers(campusForTeachers);
    } else if (typeof applyTeachers === 'function') {
      applyTeachers(campusForTeachers);
    }
    if (window.block14UserSelectedCampus) {
      return; // не перезаписываем селектор — пользователь уже выбрал
    }
    
    // Явно обновляем селектор и кнопки в block14 (через глобальную функцию, если есть)
    if (typeof window.updateBlock14SelectorDisplay === 'function') {
      window.updateBlock14SelectorDisplay(campusToSelect);
    } else {
      const lang = localStorage.getItem('siteLanguage') || 'ru';
      const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
      let campusName = campusToSelect === 'tashkent' ? 'Ташкент' : 'Горки';
      if (t) {
        const campusNameMap = { 'skolkovo': t.campus_name_skolkovo, 'moscow': t.campus_name_moscow, 'gorki': t.campus_name_gorki, 'spb': t.campus_name_spb, 'tashkent': t.campus_name_tashkent };
        campusName = campusNameMap[campusToSelect] || campusName;
      }
      document.querySelectorAll('[id="block14SelectedCampus"], [id="block14SelectedCampusMobile"]').forEach(el => { el.textContent = campusName; });
    }
    
    // Обновляем активные кнопки в block14
    const block14CampusButtons = document.querySelectorAll('.block14_campus_btn');
    block14CampusButtons.forEach(btn => {
      btn.classList.remove('active');
      if (btn.getAttribute('data-campus') === campusToSelect) {
        btn.classList.add('active');
      }
    });
  }, 200);
  
  // Обновляем возрастные диапазоны в block12
  if (typeof updateBlock12AgeRanges === 'function') {
    updateBlock12AgeRanges();
  }
  
  // Устанавливаем период из CMS при изменении региона
  const block12SelectedYear = document.getElementById('block12SelectedYear');
  const defaultYear = window.block12CurrentYear || '2025-2026';
  if (block12SelectedYear) {
    const currentLang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[currentLang] ? translations[currentLang] : null;
    const yearText = t && t.block12_year ? t.block12_year : (currentLang === 'en' ? 'year' : 'год');
    block12SelectedYear.textContent = defaultYear + ' ' + yearText;
  }
  
  // Обновляем цены для выбранного кампуса с периодом из CMS
  setTimeout(() => {
    if (typeof updateBlock12PricesForYear === 'function') {
      updateBlock12PricesForYear(defaultYear, campusToSelect);
    }
  }, 200);
  
  // Обновляем тексты программ (program_title) при смене региона
  // Используем уже объявленные переменные lang и t из строки 240-241
  if (t) {
    const isUzbekistanForPrograms = name === 'Узбекистан' || name === 'Uzbekistan';
    const programTitles = document.querySelectorAll('.program_title');
    
    // Используем узбекские переводы для program_title, если регион = Узбекистан
    let programTitleTranslations;
    if (isUzbekistanForPrograms && t.program_title_kindergarten_uzbekistan) {
      programTitleTranslations = [
        t.program_title_kindergarten_uzbekistan,
        t.program_title_primary_uzbekistan,
        t.program_title_middle_uzbekistan,
        t.program_title_high_uzbekistan
      ];
    } else {
      programTitleTranslations = [t.program_title_kindergarten, t.program_title_primary, t.program_title_middle, t.program_title_high];
    }
    
    programTitles.forEach((title, index) => {
      if (index < programTitleTranslations.length) {
        title.innerHTML = programTitleTranslations[index];
      }
    });
  }
  
  // Обновляем стоимость тестирования в аккордеоне при смене региона (не на странице детского сада — там контент с сервера)
  if (t) {
    const block10 = document.getElementById('block10');
    const accordionItems = block10 ? block10.querySelectorAll('.accordion_item') : [];
    const isServerRenderedAdmission = block10 && (
      block10.hasAttribute('data-secondary-admission-accordion') ||
      (accordionItems.length >= 1 && accordionItems[0].classList.contains('admission_accordion_item'))
    );
    if (accordionItems.length >= 3 && !isServerRenderedAdmission) {
      const item0 = accordionItems[0];
      const content0 = item0.querySelector('.accordion_content');
      if (content0) {
        const isUzbekistanForCost = name === 'Узбекистан' || name === 'Uzbekistan';
        
        // Выбираем правильный текст стоимости в зависимости от региона
        let stage1Text6 = t.stage1_text6;
        if (isUzbekistanForCost && t.stage1_text6_uzbekistan) {
          stage1Text6 = t.stage1_text6_uzbekistan;
        }
        
        // Пересоздаем весь контент аккордеона с правильной стоимостью
        // Очищаем тире из текста стоимости, если они есть
        const cleanStage1Text6 = stage1Text6 ? stage1Text6.replace(/^—\s*/, '').replace(/^—/, '').trim() : '';
        
        content0.innerHTML = '<div class="accordion_column_left">' +
          '<p><strong>' + t.stage1_text1 + '</strong></p>' +
          '<p><span class="accordion_dash">—</span> ' + (t.stage1_text2 ? t.stage1_text2.replace(/^—\s*/, '') : '') + '</p>' +
          '<p><span class="accordion_dash">—</span> ' + (t.stage1_text3 ? t.stage1_text3.replace(/^—\s*/, '') : '') + '</p>' +
          '<p>' + t.stage1_text4 + '</p>' +
          '<p><strong>' + t.stage1_text5 + '</strong></p>' +
          '<p><span class="accordion_dash">—</span>  ' + cleanStage1Text6 + '</p>' +
          '</div>' +
          '<div class="accordion_column_right">' +
          '<p><strong>' + t.stage1_text7 + '</strong></p>' +
          '<p>' + t.stage1_text8 + '</p>' +
          '<p>' + t.stage1_text9 + '</p>' +
          '</div>';
      }
    }
  }
  
  // Обновляем иконки социальных сетей в block21_social
  // Zen/Instagram зависят от страны в URL (ru-ru, en-gb = Zen; ru-uz = Instagram), а не от cookie
  const block21Social = document.querySelector('.block21_social');
  if (block21Social) {
    const pathMatch = window.location.pathname.match(/^\/([a-z]{2})-([a-z]{2})(\/.*)?$/);
    const urlCountry = pathMatch ? pathMatch[2] : 'ru';
    const urlCountryIsUz = urlCountry === 'uz';

    // Обновляем ссылку Telegram: для Узбекистана — канал Tashkent, для России — чат
    const telegramLink = block21Social.querySelector('a.block21_social_icon img[src*="Red_TG"]')?.closest('a');
    if (telegramLink) {
      const telegramHref = isUzbekistan ? block21Social.dataset.telegramUz : block21Social.dataset.telegramRu;
      if (telegramHref) telegramLink.href = telegramHref;
    }

    // Обновляем текст ссылки в зависимости от региона
    const block21SocialLink = block21Social.querySelector('.block21_social_link');
    if (block21SocialLink) {
      if (isUzbekistan) {
        block21SocialLink.textContent = '@cis_tashkent';
      } else {
        block21SocialLink.textContent = '@CISEducationalGroup';
      }
    }
    
    // Zen/Instagram по URL: ru-ru, en-gb → Zen; ru-uz → Instagram
    const existingZenIcon = block21Social.querySelector('a.block21_social_icon img[alt="Zen"], a.block21_social_icon img[src*="zen"]');
    const existingInstIcon = block21Social.querySelector('a.block21_social_icon img[src*="inst.svg"]');
    
    if (urlCountryIsUz) {
      if (existingZenIcon) {
        existingZenIcon.closest('a.block21_social_icon').remove();
      }
      if (existingInstIcon) {
        existingInstIcon.closest('a.block21_social_icon').remove();
      }
      // Для ru-uz добавляем Instagram
      const instIconLink = document.createElement('a');
      instIconLink.href = 'https://www.instagram.com/cis_tashkent';
      instIconLink.className = 'block21_social_icon';
      const instIconImg = document.createElement('img');
      instIconImg.src = landingAssetPath('/landing_2025/src/icon/inst.svg');
      instIconImg.alt = 'Instagram';
      instIconLink.appendChild(instIconImg);
      block21Social.appendChild(instIconLink);
    } else {
      // Для ru-ru, en-gb: удаляем Instagram, добавляем Zen если нет
      if (existingInstIcon) {
        existingInstIcon.closest('a.block21_social_icon').remove();
      }
      if (!existingZenIcon) {
        const zenIconLink = document.createElement('a');
        zenIconLink.href = 'https://dzen.ru/cisinternationalschool';
        zenIconLink.className = 'block21_social_icon';
        zenIconLink.target = '_blank';
        zenIconLink.rel = 'noopener';
        const zenIconImg = document.createElement('img');
        zenIconImg.src = landingAssetPath('/landing_2025/src/icon/icon_zen.svg');
        zenIconImg.alt = 'Zen';
        zenIconLink.appendChild(zenIconImg);
        block21Social.appendChild(zenIconLink);
      }
    }
  }
  
  // Обновляем school_logo2 в первом слайде block1 для узбекской версии
  const heroSlides = document.getElementById('heroSlides');
  if (heroSlides) {
    const firstSlide = heroSlides.querySelector('.hero-slide');
    if (firstSlide) {
      const schoolLogo2Img = firstSlide.querySelector('.school_logo2 img');
      if (schoolLogo2Img) {
        if (isUzbekistan) {
          // Для узбекской версии используем Slide-1_uzb.webp
          firstSlide.setAttribute('data-school-logo', landingAssetPath('/landing_2025/src/img/All/Slide-1_uzb.webp'));
          schoolLogo2Img.src = landingAssetPath('/landing_2025/src/img/All/Slide-1_uzb.webp');
          // Обновляем через функцию setBlock1SchoolLogo
          if (typeof window.setBlock1SchoolLogo === 'function') {
            window.setBlock1SchoolLogo(landingAssetPath('/landing_2025/src/img/All/Slide-1_uzb.webp'));
          }
        } else {
          // Для российской версии используем оригинальное изображение
          firstSlide.setAttribute('data-school-logo', landingAssetPath('/landing_2025/src/img/school_logo.webp'));
          schoolLogo2Img.src = landingAssetPath('/landing_2025/src/img/school_logo.webp');
          // Обновляем через функцию setBlock1SchoolLogo
          if (typeof window.setBlock1SchoolLogo === 'function') {
            window.setBlock1SchoolLogo(landingAssetPath('/landing_2025/src/img/school_logo.webp'));
          }
        }
      }
    }
  }
  
  // Обновляем фото и текст в block2 в зависимости от региона
  const block2Image = document.querySelector('.info_img_jessica');
  const block2Name = document.querySelector('.info_jessica');
  const block2Position = document.querySelector('.info_jessica_2');
  
  if (block2Image) {
    if (isUzbekistan) {
      block2Image.src = landingAssetPath('/landing_2025/src/img/Campus heads/Runar_Salimullin_transparent.webp');
      block2Image.alt = 'Runar Salimullin';
      // Убеждаемся, что применяются те же стили, что и для русской версии
      block2Image.style.width = '';
      block2Image.style.maxWidth = '';
      block2Image.style.height = '';
      block2Image.style.objectFit = '';
      block2Image.style.objectPosition = '';
    } else {
      block2Image.src = landingAssetPath('/landing_2025/src/img/JS.webp');
      block2Image.alt = 'js';
      // Убеждаемся, что применяются те же стили
      block2Image.style.width = '';
      block2Image.style.maxWidth = '';
      block2Image.style.height = '';
      block2Image.style.objectFit = '';
      block2Image.style.objectPosition = '';
    }
  }
  
  if (block2Name) {
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    if (typeof translations !== 'undefined' && translations[lang]) {
      const t = translations[lang];
      if (isUzbekistan) {
        block2Name.textContent = t.block2_jessica_uzbekistan || 'Рунар Салимуллин';
      } else {
        block2Name.textContent = t.block2_jessica || 'Джесси Ричардсон';
      }
    } else {
      block2Name.textContent = isUzbekistan ? 'Рунар Салимуллин' : 'Джесси Ричардсон';
    }
  }
  
  if (block2Position) {
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    if (typeof translations !== 'undefined' && translations[lang]) {
      const t = translations[lang];
      if (isUzbekistan) {
        block2Position.textContent = t.block2_director_uzbekistan || 'Директор кампуса Ташкент';
      } else {
        block2Position.textContent = t.block2_director || 'Директор Кампуса Москва';
      }
    } else {
      block2Position.textContent = isUzbekistan ? 'Директор кампуса Ташкент' : 'Директор Кампуса Москва';
    }
  }
  
  // Обновляем текст карусели block2 в зависимости от региона
  const carouselTexts = document.querySelectorAll('.info_school_2_carousel .info_school_2_text');
  if (carouselTexts.length >= 3) {
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
    if (t) {
      const isUzbekistan = name === 'Узбекистан' || name === 'Uzbekistan';
      carouselTexts[1].textContent = isUzbekistan ? (t.block2_carousel_item2_uzbekistan || t.block2_carousel_item2) : t.block2_carousel_item2;
    }
  }
  
  // Обновляем переводы block6 в зависимости от региона
  const currentLang = localStorage.getItem('siteLanguage') || 'ru';
  if (typeof window.updateBlock6Translations === 'function') {
    window.updateBlock6Translations(currentLang);
  }
  
  // Обновляем promo_text2 в зависимости от региона
  const allPromoText2 = document.querySelectorAll('.promo_text2');
  allPromoText2.forEach(promoText2 => {
    if (!promoText2) return;
    
    const isUzbekistan = name === 'Узбекистан' || name === 'Uzbekistan';
    let currentText = promoText2.innerHTML || promoText2.textContent || '';
    
    // Для Узбекистана: "2-18", для России: "2.5-18"
    if (isUzbekistan) {
      currentText = currentText.replace(/2\.5-18/g, '2-18');
    } else {
      currentText = currentText.replace(/2-18/g, '2.5-18');
    }
    
    // Обновляем age_badge в зависимости от региона
    const ageBadges = document.querySelectorAll('.age_badge');
    if (ageBadges.length > 0) {
      const lang = localStorage.getItem('siteLanguage') || 'ru';
      const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
      if (t) {
        // Для Узбекистана: первый badge "2-5 лет" (ru) или "2-5 years" (en), для России: "2.5-5 лет" (ru) или "2.5-5 years" (en)
        let firstAgeBadge;
        if (isUzbekistan) {
          firstAgeBadge = lang === 'en' ? 'Ages 2-5' : '2-5 лет';
        } else {
          firstAgeBadge = t.age_3_5;
        }
        const ageBadgeTranslations = [firstAgeBadge, t.age_5_11, t.age_11_14, t.age_14_18];
        ageBadges.forEach((badge, index) => {
          if (index < ageBadgeTranslations.length) {
            badge.textContent = ageBadgeTranslations[index];
          }
        });
      }
    }
    
    promoText2.innerHTML = currentText;
    if (promoText2.dataset.originalText) {
      promoText2.dataset.originalText = currentText;
    }
    
    // Обновляем через функцию updatePromoText2, если доступна
    if (typeof window.updatePromoText2 === 'function') {
      window.updatePromoText2(promoText2, currentText);
    }
  });
  
  // Обновляем номер телефона в .contacts .phone в зависимости от региона
  const contactsPhone = document.querySelector('.contacts .phone');
  if (contactsPhone) {
    const isUzbekistan = name === 'Узбекистан' || name === 'Uzbekistan';
    // Для Узбекистана - номер +998 (71) 209 66 69, для России - 8 800 775 42 70
    const phoneNumber = isUzbekistan ? '+998 (71) 209 66 69' : '8 800 775 42 70';
    contactsPhone.textContent = phoneNumber;
  }

  // Обновляем ссылки звонка, WhatsApp и Telegram в шапке при смене региона
  const isUzbekistanForLinks = name === 'Узбекистан' || name === 'Uzbekistan';
  const langForLinks = localStorage.getItem('siteLanguage') || 'ru';
  const tForLinks = typeof translations !== 'undefined' && translations[langForLinks] ? translations[langForLinks] : null;
  const greetingForLinks = (tForLinks && tForLinks.header_greeting) ? encodeURIComponent(tForLinks.header_greeting) : (langForLinks === 'en' ? encodeURIComponent('Hello. I would like to apply for an openday.') : encodeURIComponent('Добрый день. Хочу записаться на день открытых дверей.'));
  const whatsappNum = isUzbekistanForLinks ? '998903484540' : '79680971592';
  const telegramNum = isUzbekistanForLinks ? '+998903484540' : '+79680971592';
  const callHref = isUzbekistanForLinks ? 'tel:+998712096669' : 'tel:88007754270';
  const callLinks = document.querySelectorAll('.top_bar .icons a.call, .contacts a.call');
  const whatsappLinks = document.querySelectorAll('.top_bar .icons a.whatsapp, .contacts a.whatsapp');
  const telegramLinks = document.querySelectorAll('.top_bar .icons a.telegram, .contacts a.telegram');
  callLinks.forEach(link => { link.href = callHref; });
  whatsappLinks.forEach(link => { link.href = `https://web.whatsapp.com/send?phone=${whatsappNum}&text=${greetingForLinks}`; });
  telegramLinks.forEach(link => { link.href = `https://t.me/${telegramNum}?text=${greetingForLinks}`; });
  
  // Обновляем alt_text с правильным номером телефона в зависимости от региона
  const altTexts = document.querySelectorAll('.alt_text, .form_step2_alt_text');
  altTexts.forEach(alt => {
    // Пропускаем block20_consent - у него свой текст
    const isBlock20Consent = alt.classList.contains('block20_consent');
    if (isBlock20Consent) {
      return;
    }
    
    // Определяем регион для выбора правильного номера телефона
    const isUzbekistan = name === 'Узбекистан' || name === 'Uzbekistan';
    
    // Получаем текущий язык для перевода текста
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
    const altText = t && t.form_alt_text ? t.form_alt_text : 'Также вы можете оставить заявку, позвонив по телефону';
    
    // Для Узбекистана - номер +998 (71) 209 66 69, для России - 8 800 551 43 96
    const phoneNumber = isUzbekistan ? '+998 (71) 209 66 69' : '8 800 551 43 96';
    const phoneHref = isUzbekistan ? 'tel:+998712096669' : 'tel:88005514396';
    
    alt.innerHTML = altText + ' <a href="' + phoneHref + '">' + phoneNumber + '</a>';
  });
  
  // Обновляем все тексты страницы, включая block15_description, при смене региона
  // Получаем актуальный язык из localStorage
  const applyRegionLang = localStorage.getItem('siteLanguage') || 'ru';
  if (typeof window.translatePage === 'function') {
    // Передаем имя региона напрямую, чтобы избежать проблем с задержкой обновления cookie
    // Вызываем сразу и с несколькими задержками для гарантии обновления всех элементов футера
    window.translatePage(applyRegionLang, name);
    setTimeout(() => {
      window.translatePage(applyRegionLang, name);
    }, 50);
    setTimeout(() => {
      window.translatePage(applyRegionLang, name);
    }, 150);
    setTimeout(() => {
      window.translatePage(applyRegionLang, name);
    }, 300);
  }
  
  // Автоматически выбираем кампус в блоке цен при смене региона: Россия → Горки, Узбекистан → Ташкент
  setTimeout(() => {
    const isUzbekistan = name === 'Узбекистан' || name === 'Uzbekistan';
    const campusToSelect = isUzbekistan ? 'tashkent' : 'gorki';
    if (typeof window.selectBlock12Campus === 'function') {
      window.selectBlock12Campus(campusToSelect);
    }
  }, 100);
  
  // Автоматически выбираем кампус в форме "скачать брошюру" при смене региона
  setTimeout(() => {
    const formCampusInput = document.getElementById('campus');
    const formSelectedCampus = document.getElementById('formSelectedCampus');
    const formCampusModal = document.getElementById('formCampusModal');
    const formCampusBtn = document.getElementById('formCampusBtn');
    
    if (formCampusInput && formSelectedCampus && formCampusModal && formCampusBtn) {
      // Определяем регион
      const isUzbekistan = name === 'Узбекистан' || name === 'Uzbekistan';
      const campusToSelect = isUzbekistan ? 'tashkent' : 'gorki';
      
      // Вызываем функцию выбора кампуса, если она доступна
      if (typeof window.selectFormCampus === 'function') {
        window.selectFormCampus(campusToSelect, formSelectedCampus, formCampusInput, formCampusModal, formCampusBtn);
      } else {
        // Fallback: обновляем вручную
        const currentLang = localStorage.getItem('siteLanguage') || 'ru';
        const t = typeof translations !== 'undefined' && translations[currentLang] ? translations[currentLang] : null;
        const formCampusNames = {
          skolkovo: "Сколково",
          moscow: "Москва",
          gorki: "Горки",
          spb: "Санкт-Петербург",
          tashkent: "Ташкент"
        };
        const campusName = t && t[`campus_name_${campusToSelect}`] ? t[`campus_name_${campusToSelect}`] : formCampusNames[campusToSelect];
        
        if (campusName) {
          // Убираем класс selected со всех опций
          const allOptions = formCampusModal.querySelectorAll(".form_campus_option");
          allOptions.forEach(option => {
            option.classList.remove("selected");
          });
          
          // Добавляем класс selected к выбранной опции (data-value = id, campusToSelect = slug)
          const selectedOption = formCampusModal.querySelector(`.form_campus_option[data-slug="${campusToSelect}"]`);
          if (selectedOption) {
            selectedOption.classList.add("selected");
          }
          
          // Обновляем отображаемый текст и значение
          formSelectedCampus.textContent = campusName;
          formCampusInput.value = selectedOption ? selectedOption.getAttribute("data-value") : campusToSelect;
          
          // Закрываем модальное окно, если оно открыто
          formCampusModal.classList.remove("open");
          formCampusBtn.classList.remove("menu-open");
          
          // Обновляем кнопку после выбора кампуса
          if (typeof window.updateBlock7DownloadButton === 'function') {
            window.updateBlock7DownloadButton();
          }
        }
      }
    }
  }, 200);
}

// Экспортируем applyRegion глобально
window.applyRegion = applyRegion;

// Функция для обновления текстов block17 в зависимости от региона
function updateBlock17TextsForRegion(regionName) {
  const block17AnswerContainers = document.querySelectorAll('.block17_accordion_content');
  if (block17AnswerContainers.length < 14) return;
  
  const isUzbekistan = regionName === 'Узбекистан' || regionName === 'Uzbekistan';
  const lang = localStorage.getItem('siteLanguage') || 'ru';
  const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
  
  if (!t) return;
  
  // Ответ 4: "С какого возраста принимаются дети?"
  block17AnswerContainers[3].innerHTML = '<p>' + ((isUzbekistan && t.block17_answer4_uzbekistan)
    ? t.block17_answer4_uzbekistan
    : t.block17_answer4) + '</p>';
  
  // Ответ 5: "По какой программе происходит обучение?"
  block17AnswerContainers[4].innerHTML = '<p>' + ((isUzbekistan && t.block17_answer5_uzbekistan)
    ? t.block17_answer5_uzbekistan
    : t.block17_answer5) + '</p>';
  
  // Ответ 11: "В какие вузы поступают ваши выпускники?"
  block17AnswerContainers[10].innerHTML = '<p>' + ((isUzbekistan && t.block17_answer11_uzbekistan)
    ? t.block17_answer11_uzbekistan
    : t.block17_answer11) + '</p>';
}

// Экспортируем updateBlock17TextsForRegion глобально
window.updateBlock17TextsForRegion = updateBlock17TextsForRegion;

// ---------- Инициализация ----------
function initRegionSelector() {
  // Получаем элементы после загрузки DOM
  btn = document.getElementById("regionBtn");
  modal = document.getElementById("regionModal");
  curCountry = document.getElementById("curCountry");
  curFlag = document.getElementById("curFlag");
  logoFlag = null; // Флаг не отображается в логотипе
  options = document.querySelectorAll(".country_option");
  closeBtn = document.querySelector(".close_btn");

  // Сразу вешаем клики по шапке — до applyRegion/updateRegion, чтобы любая ошибка ниже не лишала страницу интерактива.
  // internal_2025 (primary / middle-high): тот же UI вешает public/*/js/script.js (initSecondaryRegionSelector).
  const regionUiHandledByInternalScript =
    document.body &&
    (document.body.classList.contains("primary-school-page") ||
      document.body.classList.contains("middle-high-page"));

  if (!regionUiHandledByInternalScript) {
    if (btn) {
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        if (modal) modal.classList.toggle("open");
        btn.classList.toggle("active");
      });
    }

    if (options && options.length > 0) {
      options.forEach((opt) => {
        opt.addEventListener("click", (e) => {
          if (e.target.classList.contains("close_btn") || e.target.closest(".close_btn")) return;

          const countryName = opt.getAttribute("data-country");
          const countryFlag = opt.getAttribute("data-flag");

          if (countryName && countryFlag) {
            const r = { name: countryName, flag: countryFlag };
            saveRegion(r);
          }
        });
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        closeModal();
      });
    }

    document.addEventListener("click", (e) => {
      if (btn && modal && !btn.contains(e.target) && !modal.contains(e.target)) {
        closeModal();
      }
    });
  }
  
  // Функция для безопасного вызова fixLogoWidth
  const safeFixLogoWidth = () => {
    try {
      fixLogoWidth();
    } catch (e) {
      console.error('Ошибка при фиксации ширины logo:', e);
    }
  };
  
  // Фиксируем ширину logo сразу после загрузки DOM
  safeFixLogoWidth();
  
  // Также фиксируем с небольшой задержкой на случай если DOM еще не полностью готов
  setTimeout(() => {
    safeFixLogoWidth();
  }, 50);
  
  // Вызываем fixLogoWidth после полной загрузки страницы (включая изображения)
  if (document.readyState === 'complete') {
    safeFixLogoWidth();
  } else {
    window.addEventListener('load', () => {
      safeFixLogoWidth();
    });
  }
  
  // Обработчик загрузки изображения logo
  const logoImg = document.querySelector('.logo img');
  if (logoImg) {
    // Если изображение уже загружено и имеет размер
    if (logoImg.complete && logoImg.naturalWidth > 0) {
      safeFixLogoWidth();
    } else {
      // Если изображение еще загружается, ждем его загрузки
      logoImg.addEventListener('load', () => {
        safeFixLogoWidth();
      }, {once: true});
      
      // Также обрабатываем случай, если изображение загрузилось с ошибкой
      logoImg.addEventListener('error', () => {
        // Даже если изображение не загрузилось, все равно фиксируем ширину на основе текста
        safeFixLogoWidth();
      }, {once: true});
    }
  }
  
  // Обновляем ширину logo при изменении размера окна
  let logoResizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(logoResizeTimeout);
    logoResizeTimeout = setTimeout(() => {
      fixLogoWidth();
    }, 100);
  });
  
  // Инициализация обработчиков кнопок скачивания PDF в третьей карточке block13
  // Используем setTimeout, чтобы убедиться, что элементы уже в DOM
  setTimeout(() => {
    initBlock13DownloadButtons();
  }, 100);

  // Hero promo_text должен быть <p>, не <h2> — исправляем на случай h2 из CMS/кэша
  setTimeout(() => {
    if (typeof window.ensurePromoTextIsP === 'function') {
      window.ensurePromoTextIsP();
    }
  }, 50);
  
  // Синхронизация URL с сохранённым регионом: только для ru-ru/ru-uz (не для en-gb!)
  // en-gb не имеет варианта по стране — редирект на en-ru вызывает бесконечный цикл (en-ru → en-gb)
  // Не редиректим с ru-uz/en-uz, если URL явно указывает на Узбекистан — пользователь мог перейти по ссылке
  const pathMatch = window.location.pathname.match(/^\/([a-z]{2})-([a-z]{2})(\/.*)?$/);
  const countryMap = { 'Россия': 'ru', 'Russia': 'ru', 'Узбекистан': 'uz', 'Uzbekistan': 'uz' };

  // internal_2025: на главной/детсаду регион пишется в cambridge_region через saveRegion; на primary script.js
  // обновлял только localStorage siteCountry — старая кука «Узбекистан» оставалась, блок ниже редиректил ru-ru → ru-uz.
  if (
    document.body &&
    (document.body.classList.contains('primary-school-page') || document.body.classList.contains('middle-high-page')) &&
    pathMatch &&
    typeof window.setCookie === 'function' &&
    typeof window.COOKIE_NAME !== 'undefined' &&
    typeof window.COOKIE_DAYS !== 'undefined'
  ) {
    const lang = pathMatch[1];
    const seg = pathMatch[2].toLowerCase();
    const isUz = seg === 'uz';
    const r = {
      name: lang === 'en' ? (isUz ? 'Uzbekistan' : 'Russia') : (isUz ? 'Узбекистан' : 'Россия'),
      flag: isUz ? landingAssetPath('/landing_2025/src/icon/uzb.webp') : landingAssetPath('/landing_2025/src/icon/rf.webp')
    };
    window.setCookie(window.COOKIE_NAME, JSON.stringify(r), window.COOKIE_DAYS);
  }

  const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined')
    ? window.getCookie(window.COOKIE_NAME)
    : (typeof getCookie === 'function' && typeof COOKIE_NAME !== 'undefined' ? getCookie(COOKIE_NAME) : null);
  if (saved && pathMatch && pathMatch[2] !== 'uz') {
    try {
      const lang = pathMatch[1];
      if (lang === 'ru') {
        const r = JSON.parse(saved);
        const cookieCountry = countryMap[r.name] || 'ru';
        if (pathMatch[2] !== cookieCountry) {
          const rest = pathMatch[3] || '/';
          window.location.href = '/' + lang + '-' + cookieCountry + rest;
          return;
        }
      }
    } catch (e) { /* ignore */ }
  }
  if (saved) {
    try {
      let r = JSON.parse(saved);
      // Для en-uz и ru-uz: регион из URL (cookie может быть от предыдущего визита)
      if (pathMatch && pathMatch[2] === 'uz') {
        r = { name: pathMatch[1] === 'en' ? 'Uzbekistan' : 'Узбекистан', flag: r.flag || landingAssetPath('/landing_2025/src/icon/uzb.webp') };
        updateRegion(r);
        if (typeof window.setCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined' && typeof window.COOKIE_DAYS !== 'undefined') {
          window.setCookie(window.COOKIE_NAME, JSON.stringify(r), window.COOKIE_DAYS);
        }
      } else {
        updateRegion(r);
      }
      
      // Устанавливаем кампус по умолчанию в зависимости от региона
      // Для Узбекистана - Ташкент, для России - Горки
      const isUzbekistanRegion = r.name === 'Узбекистан' || r.name === 'Uzbekistan';
      const defaultCampusId = isUzbekistanRegion ? 'tashkent' : 'gorki';
      
      // Сначала вызываем applyRegion, чтобы обновить регион
      applyRegion(r.name);
      
      // Затем используем selectBlock20Campus для обновления кампуса БЕЗ обновления карты
      // Вызываем с задержкой после applyRegion, чтобы избежать конфликта
      // Не затираем block12, если пользователь уже выбрал кампус в селекторе цен (priceSlider)
      setTimeout(() => {
        if (window.block12CampusChosenByUser) return;
        if (typeof window.selectBlock20Campus === 'function') {
          window.selectBlock20Campus(defaultCampusId, false); // false = не обновлять карту
        } else if (typeof selectBlock20Campus === 'function') {
          selectBlock20Campus(defaultCampusId, false); // false = не обновлять карту
        } else {
          // Fallback: используем syncCampusSelection и updateCampusInfo
          if (typeof syncCampusSelection === 'function') {
            syncCampusSelection(defaultCampusId);
          }
          setTimeout(() => {
            if (typeof updateCampusInfo === 'function') {
              updateCampusInfo(defaultCampusId);
            } else if (typeof window.updateCampusInfo === 'function') {
              window.updateCampusInfo(defaultCampusId);
            }
          }, 100);
        }
      }, 500);
      
      // Загружаем фотографии для выбранного кампуса в slider_container (block5)
      setTimeout(() => {
        if (typeof loadCampusImages === 'function') {
          // Загружаем фотографии территории для выбранного кампуса
          loadCampusImages(defaultCampusId, "tgn");
        }
      }, 600);
      // Обновляем тексты block17 после установки региона
      setTimeout(() => {
        updateBlock17TextsForRegion(r.name);
      }, 100);
    } catch (e) {
      console.error("Ошибка при загрузке сохраненного региона:", e);
      const def = {name: "Россия", flag: landingAssetPath("/landing_2025/src/icon/rf.webp")};
      updateRegion(def);
      applyRegion(def.name);
      // Обновляем тексты block17 после установки региона
      setTimeout(() => {
        updateBlock17TextsForRegion(def.name);
      }, 100);
    }
  } else {
    // По-умолчанию – Россия, но для en-uz/ru-uz используем регион из URL
    let def;
    if (pathMatch && pathMatch[2] === 'uz') {
      def = { name: pathMatch[1] === 'en' ? 'Uzbekistan' : 'Узбекистан', flag: landingAssetPath("/landing_2025/src/icon/uzb.webp") };
      if (typeof window.setCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined' && typeof window.COOKIE_DAYS !== 'undefined') {
        window.setCookie(window.COOKIE_NAME, JSON.stringify(def), window.COOKIE_DAYS);
      }
    } else {
      def = { name: "Россия", flag: landingAssetPath("/landing_2025/src/icon/rf.webp") };
    }
    updateRegion(def);
    applyRegion(def.name);
    // Обновляем тексты block17 после установки региона
    setTimeout(() => {
      updateBlock17TextsForRegion(def.name);
    }, 100);
  }
  
  // Функция для установки кампуса по умолчанию в зависимости от региона
  function setDefaultCampusForRegion() {
    const curCountryEl = document.getElementById('curCountry');
    if (!curCountryEl) return;
    
    const isUzbekistanRegion = curCountryEl.textContent.trim() === 'Узбекистан' || curCountryEl.textContent.trim() === 'Uzbekistan';
    // Для Узбекистана - Ташкент, для России - Горки
    const defaultCampusId = isUzbekistanRegion ? 'tashkent' : 'gorki';
    
    // Синхронизируем выбор кампуса во всех блоках (не перетираем ручной выбор в block12)
    if (typeof syncCampusSelection === 'function' && !window.block12CampusChosenByUser) {
      syncCampusSelection(defaultCampusId);
    }
    
    // Обновляем информацию о кампусе в block20 (включая контакты)
    setTimeout(() => {
      if (typeof updateCampusInfo === 'function') {
        updateCampusInfo(defaultCampusId);
      } else if (typeof window.updateCampusInfo === 'function') {
        window.updateCampusInfo(defaultCampusId);
      }
    }, 100);
    
    // Загружаем фотографии для выбранного кампуса в slider_container (block5)
    if (typeof loadCampusImages === 'function') {
      // Загружаем фотографии территории для выбранного кампуса
      loadCampusImages(defaultCampusId, "tgn");
    }
    
    // Обновляем преподавателей для выбранного кампуса
    // НЕ перезаписываем, если пользователь уже выбрал кампус в block14 вручную
    setTimeout(() => {
      const campusForTeachers = window.block14UserSelectedCampus || defaultCampusId;
      if (typeof window.applyTeachers === 'function') {
        window.applyTeachers(campusForTeachers);
      } else if (typeof applyTeachers === 'function') {
        applyTeachers(campusForTeachers);
      }
      
      // Обновляем отзывы для выбранного кампуса
      if (typeof window.updateReviewsForCampus === 'function') {
        window.updateReviewsForCampus(campusForTeachers);
      }
    }, 100);
    
    // Обновляем возрастные диапазоны в block12
    if (typeof updateBlock12AgeRanges === 'function') {
      updateBlock12AgeRanges();
    }
  }
  
  // Устанавливаем кампус по умолчанию после небольшой задержки, чтобы убедиться, что все элементы загружены
  setTimeout(() => {
    setDefaultCampusForRegion();
  }, 200);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initRegionSelector);
} else {
  initRegionSelector();
}
